module.exports = __webpack_public_path__ + "static/media/union-cover.6704a7d8.jpg";